<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 mb-3">
            <label>{{ $t('common_words.farm') }}</label>
            <br />
            <el-select
              clearable
              @change="showCalendar()"
              filterable
              class="select-primary custom-width-select shadow-sm farm-form"
              size="large"
              v-model="ringingJournalForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-lg-4 mb-3">
            <label>{{ $t('production.motive') }}</label>
            <br />
            <el-select
              clearable
              @change="hideView"
              filterable
              class="select-primary custom-width-select shadow-sm reason-form"
              size="large"
              v-model="ringingJournalForm.ringing_reason_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in ringing_reasons"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-3">
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              @change="hideView"
              :picker-options="pickerOptions"
              class="shadow-sm date-form"
              v-model="ringingJournalForm.date"
              type="date"
              range-separator="-"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-12 col-xl-6">
            <div class="row custom-mt-30">
              <div class="col-12 col-sm-6 col-md-8 col-lg-3 col-xl-3 mb-2">
                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  @click="generate"
                  style="width: inherit"
                >
                  {{ $t('common_words.generate') }}
                </l-button>
              </div>
              <div
                class="col-12 col-sm-6 col-md-8 col-lg-4 col-xl-5"
                v-if="isRingingCatchAdmin()"
              >
                <el-button
                  wide
                  type="info"
                  icon="el-icon-s-tools"
                  class="btn-filter"
                  style="padding: 11px 20px; width: inherit"
                  @click="openAdminPermissions()"
                >
                  {{ $t('common_words.manage_permissions') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <br />
      </card>
      <admin-journal-permissions
        @showHideLoading="showHideLoading"
        @showMessageErrors="showMessageErrors"
        @showNotification="notification"
        @closeAdminPermissions="closeAdminPermissions"
        @updateInfoPermission="updateInfoPermission"
        :visible="ringingCatchAdmin"
      />
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="showTable"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table
                class="table table-striped table-bordered table table-journals"
              >
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th
                      style="width: 200px"
                      scope="col"
                      class="text-center p-3 custom-header-label"
                    >
                      {{ $t('common_words.allotment_age') }}
                    </th>
                    <template
                      v-for="(row, i) in ringingJournalForm.week_columns"
                    >
                      <th
                        :key="i"
                        class="text-center p-3"
                        v-bind:style="
                          'width: 100px; font-size: smaller;background-color:' +
                          row.color +
                          ';color:' +
                          row.color_text +
                          '; font-weight: bold; text-transform: capitalize !important;'
                        "
                        v-if="showEdgeColumn(`week_${i + 1}`)"
                      >
                        {{ i + 1 }} {{ $t('common_words.week_short') }}
                      </th>
                    </template>

                    <th
                      style="width: 150px"
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-if="showEdgeColumn(`youths`)"
                    >
                      {{ $t('production.young') }}
                    </th>

                    <th
                      style="width: 150px"
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-if="showEdgeColumn(`bacotas`)"
                    >
                      {{ $t('production.banana_flowers') }}
                    </th>

                    <th
                      style="width: 100px"
                      scope="col"
                      class="text-center p-3 custom-header-label"
                    >
                      {{ $t('common_words.total') }}
                    </th>

                    <th
                      style="width: 30px"
                      v-if="!messageAlert"
                      scope="col"
                      class="text-center p-3 custom-header-label"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in ringingJournalForm.nRinging" :key="i">
                    <td class="text-center">
                      <el-select
                        style="width: 200px; margin: auto"
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="large"
                        v-model="ringingJournalForm.lots_sel[i]"
                        @change="changeArray(i)"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="l in availableLots"
                          class="select-primary"
                          :value="l.id"
                          :label="l.name"
                          :key="l.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <template
                      v-for="(
                        column, indexWeekColumns
                      ) in ringingJournalForm.week_columns"
                    >
                      <td
                        class="text-center"
                        :key="indexWeekColumns"
                        v-if="showEdgeColumn(`week_${column.edge}`)"
                      >
                        <el-input
                          style="width: 100px"
                          type="number"
                          min="0"
                          max="9999"
                          class="shadow-sm text-center required-inputs"
                          pattern="/^-?\d+\.?\d*$/"
                          onKeyPress="if(this.value.length==4) return false;"
                          :disabled="!ringingJournalForm.lots_sel[i]"
                          v-model="
                            ringingJournalForm.inputs[
                              ringingJournalForm.lots_sel[i] + '-' + column.edge
                            ]
                          "
                        />
                      </td>
                    </template>
                    <td class="text-center" v-if="showEdgeColumn(`youths`)">
                      <el-input
                        style="width: 150px"
                        type="number"
                        min="0"
                        max="9999"
                        pattern="/^-?\d+\.?\d*$/"
                        onKeyPress="if(this.value.length==4) return false;"
                        class="shadow-sm text-center required-inputs"
                        :disabled="!ringingJournalForm.lots_sel[i]"
                        v-model="
                          ringingJournalForm.inputs[
                            ringingJournalForm.lots_sel[i] + '-100'
                          ]
                        "
                      />
                    </td>
                    <td class="text-center" v-if="showEdgeColumn(`bacotas`)">
                      <el-input
                        style="width: 150px"
                        type="number"
                        min="0"
                        max="9999"
                        pattern="/^-?\d+\.?\d*$/"
                        onKeyPress="if(this.value.length==4) return false;"
                        class="shadow-sm text-center required-inputs"
                        :disabled="!ringingJournalForm.lots_sel[i]"
                        v-model="
                          ringingJournalForm.inputs[
                            ringingJournalForm.lots_sel[i] + '-200'
                          ]
                        "
                      />
                    </td>
                    <td class="text-center p-3">
                      <h5
                        class="text-muted mt-3"
                        style="width: 100px; font-weight: bold"
                      >
                        {{ calculateTotalRow(ringingJournalForm.lots_sel[i]) }}
                      </h5>
                    </td>
                    <td
                      v-if="!messageAlert"
                      class="text-center"
                      style="display: table-cell"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="
                            isUpdate() &&
                            ringingJournalForm.nRinging < lots.length
                          "
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click="addRowTable(i)"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="ringingJournalForm.nRinging > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(ringingJournalForm.lots_sel[i])"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td
                      class="text-muted text-center"
                      style="font-weight: bold"
                    >
                      {{ $t('common_words.total') }}
                    </td>
                    <template
                      v-for="(column, index) in ringingJournalForm.week_columns"
                    >
                      <td
                        class="text-center p-3"
                        style="font-weight: bold"
                        :key="index"
                        v-if="showEdgeColumn(`week_${column.edge}`)"
                      >
                        {{ calculateTotalColumn(column.edge) }}
                      </td>
                    </template>
                    <td
                      class="text-center p-3"
                      style="font-weight: bold"
                      v-if="showEdgeColumn(`youths`)"
                    >
                      {{ calculateTotalColumn(100) }}
                    </td>
                    <td
                      class="text-center p-3"
                      style="font-weight: bold"
                      v-if="showEdgeColumn(`bacotas`)"
                    >
                      {{ calculateTotalColumn(200) }}
                    </td>
                    <td class="text-center p-3">
                      <h5
                        class="text-muted mt-3"
                        style="width: 100px; font-weight: bold"
                      >
                        {{ calculateTotalColumn('all') }}
                      </h5>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div v-if="!messageAlert" class="col-12 mt-5">
              <div class="row">
                <div class="col-6 text-right">
                  <button
                    class="btn btn-fill btn-info btn-wd shadow-sm"
                    @click="validateForm"
                  >
                    {{ $t('common_words.save_data') }}
                  </button>
                </div>
                <div class="col-6">
                  <button
                    class="btn btn-fill btn-danger btn-wd shadow-sm"
                    @click="DeleteAll"
                  >
                    {{ $t('common_words.delete') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import AdminPermissions from './AdminPermissions';
import i18n from 'src/i18n';

export default {
  components: {
    [AdminPermissions.name]: AdminPermissions,
  },
  data() {
    return {
      ringingJournalForm: {
        id: null,
        farm_id: null,
        ringing_reason_id: null,
        date: moment().format('YYYY-MM-DD'),
        nRinging: 1,
        lots_sel: [],
        calendar_sel: null,
        inputs: {},
        inputs_bck: {},
        user_id: this.$store.state.auth.user.id,
      },
      old_lots_sel: [],
      totals: {},
      tableWeekColumns: [],
      showTable: false,
      farms: null,
      ringing_reasons: null,
      isShowCalendar: false,
      disables: {},
      lots: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      messageAlert: null,
      ringingCatchAdmin: false,
      permissionsForm: {
        youths: true,
        bacotas: true,
      },
    };
  },

  computed: {
    dynamicModel: () => {
      const response = {};
      Array.from({ length: 15 }, (_, i) => i + 1).forEach((i) => {
        const index = `week_${i}`;
        response[index] = true;
      });
      return response;
    },

    availableLots() {
      return this.lots.filter(
        (lot) => !this.ringingJournalForm.lots_sel.includes(lot.id)
      );
    },

    calendars() {
      if (this.ringingJournalForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          if (element.id == this.ringingJournalForm.farm_id) {
            calendars = element.calendars;
          }
        });
        return calendars;
      } else {
        return [];
      }
    },
  },

  mixins: [mixinMasters, MixinPermissions, MixinNotification, MixinMenu],

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    /**
     * Actualizar la información de permisos en la data principal una vez
     * extraida de la BD
     */
    updateInfoPermission(otherValues) {
      const otherValuesKeys = Object.keys(otherValues);
      if (otherValuesKeys.length > 0) {
        const id = otherValuesKeys[0];

        for (const index in this.permissionsForm) {
          if (otherValues[id] && otherValues[id][index]) {
            this.$set(this.permissionsForm, index, otherValues[id][index]);
          } else {
            this.$set(this.permissionsForm, index, false);
          }
        }
      } else {
        for (const index in this.permissionsForm) {
          this.$set(this.permissionsForm, index, true);
        }
      }
    },

    /**
     * Verificar si esta habilitada la columna pasada
     * por parámetro para su digitación
     * @param {*} indexColumn
     */
    showEdgeColumn(indexColumn) {
      const first =
        this.permissionsForm[indexColumn] ||
        this.journalColumnIsEnabled(indexColumn);

      return first;
    },

    /**
     * Mostrar la notificación temporal
     */
    notification({ message, type, icon, title, position }) {
      this.showNotification(message, type, icon, title, position);
    },

    /**
     * Abrir el formulario de administrador de permisos
     */
    openAdminPermissions() {
      this.ringingCatchAdmin = true;
    },

    /**
     * Cerrar el formulario de administrador de permisos
     */
    closeAdminPermissions() {
      this.ringingCatchAdmin = false;
    },

    changeArray(index) {
      if (typeof this.old_lots_sel[index] !== 'undefined') {
        for (const key in this.ringingJournalForm.inputs) {
          let split = key.split('-');
          if (split[0] == this.old_lots_sel[index]) {
            this.$set(
              this.ringingJournalForm.inputs,
              this.ringingJournalForm.lots_sel[index] + '-' + split[1],
              this.ringingJournalForm.inputs[key]
            );
            delete this.ringingJournalForm.inputs[split[0] + '-' + split[1]];
          }
        }

        delete this.totals[this.old_lots_sel[index]];
      }

      this.old_lots_sel = Object.assign([], this.ringingJournalForm.lots_sel);
    },

    addRowTable(index) {
      this.disables[index] = true;
      this.disables['undefined'] = true;
      this.ringingJournalForm.nRinging++;
    },

    hideView() {
      this.messageAlert = null;
      this.showTable = false;
    },

    cleanView() {
      this.ringingJournalForm.lots_sel = [];
      this.ringingJournalForm.inputs = {};
      this.ringingJournalForm.inputs_bck = {};
      this.ringingJournalForm.inputs_ids = {};
      this.tableWeekColumns = [];
      this.disables = {};
      this.totals = {};
    },

    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.ringingJournalForm.calendar_sel = null;
      this.showTable = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.ringingJournalForm.farm_id
      );
      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.ringingJournalForm.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }

      this.isShowCalendar = false;
    },

    generate() {
      this.cleanView();

      this.ringingJournalForm.id = null;

      if (this.ringingJournalForm.farm_id == null) {
        this.highlightItem('farm-form');
      } else if (this.ringingJournalForm.ringing_reason_id == null) {
        this.highlightItem('reason-form');
      } else if (this.ringingJournalForm.date == null) {
        this.highlightItem('date-form');
      } else {
        this.showHideLoading(true);
        this.messageAlert = null;
        this.ringingJournalForm.route = 'ringings/journals/index';

        Axios.getMasters('lots/' + this.ringingJournalForm.farm_id)
          .then((r1) => {
            Axios.saveMaster(this.ringingJournalForm)
              .then((r2) => {
                this.lots = r1.data.data;
                this.ringingJournalForm.nRinging = r2.data.nRinging;
                this.ringingJournalForm.week_columns = r2.data.week_columns;
                this.ringingJournalForm.id = r2.data.id;

                if (typeof r2.data.id !== 'undefined') {
                  this.ringingJournalForm.id = r2.data.id;
                }

                if (r2.data.lots_sel.length > 0) {
                  this.ringingJournalForm.lots_sel = r2.data.lots_sel;
                  this.ringingJournalForm.lots_sel_bck = Object.assign(
                    {},
                    this.ringingJournalForm.lots_sel
                  );
                  this.old_lots_sel = Object.assign(
                    [],
                    this.ringingJournalForm.lots_sel
                  );

                  try {
                    this.ringingJournalForm.lots_sel = [];
                    setTimeout(() => {
                      this.ringingJournalForm.lots_sel = Object.assign(
                        [],
                        this.ringingJournalForm.lots_sel_bck
                      );
                    }, 5);
                  } catch (error) {}
                } else {
                  this.disables['undefined'] = true;
                }

                if (Object.keys(r2.data.inputs).length) {
                  this.ringingJournalForm.inputs = r2.data.inputs;
                  this.ringingJournalForm.inputs_bck = Object.assign(
                    {},
                    this.ringingJournalForm.inputs
                  );
                  this.ringingJournalForm.inputs_ids = r2.data.inputs_ids;
                }

                this.ringingJournalForm.ribbons = r2.data.ribbons;

                try {
                  this.messageAlert = r2.data.closing.message;
                } catch (error) {
                  this.messageAlert = null;
                }

                this.showTable = true;
                this.showHideLoading();
              })
              .catch((error) => this.showMessageErrors(error));
          })
          .catch((error) => this.showMessageErrors(error));
      }
    },

    calculateTotalRow(index) {
      let total = 0;

      for (const key in this.ringingJournalForm.inputs) {
        let split = key.split('-');
        if (split[0] == index && this.showEdgeColumn(`week_${split[1]}`)) {
          if (
            this.ringingJournalForm.inputs[key] != null &&
            this.ringingJournalForm.inputs[key] > 0
          ) {
            total += parseFloat(this.ringingJournalForm.inputs[key]);
          }
        }
      }

      this.totals[index] = total;

      return total;
    },

    calculateTotalColumn(index) {
      let total = 0;

      if (index == 'all') {
        let values = Object.values(this.totals);

        values.forEach((elem) => {
          total += elem;
        });
      } else {
        for (const key in this.ringingJournalForm.inputs) {
          let split = key.split('-');
          if (split[1] == index) {
            if (
              this.ringingJournalForm.inputs[key] != null &&
              this.ringingJournalForm.inputs[key] > 0
            ) {
              total += parseFloat(this.ringingJournalForm.inputs[key]);
            }
          }
        }
      }

      return total;
    },

    handleDelete(index) {
      if (typeof index !== 'undefined') {
        try {
          let index1 = this.ringingJournalForm.lots_sel.findIndex(
            (lot) => lot === index
          );

          this.ringingJournalForm.lots_sel.splice(index1, 1);
          delete this.totals[index];

          let tmp = Object.assign([], this.ringingJournalForm.lots_sel);
          this.ringingJournalForm.lots_sel = [];
          setTimeout(() => {
            this.ringingJournalForm.lots_sel = Object.assign([], tmp);
            this.old_lots_sel = Object.assign([], tmp);
          }, 5);
        } catch (error) {}

        try {
          for (const key in this.ringingJournalForm.inputs) {
            let split = key.split('-');

            if (split[0] == index) {
              delete this.ringingJournalForm.inputs[key];
            }
          }
        } catch (error) {}
      } else {
        try {
          for (const key in this.ringingJournalForm.inputs) {
            let split = key.split('-');

            if (split[0] === 'undefined') {
              delete this.ringingJournalForm.inputs[key];
            }
          }
        } catch (error) {}
      }

      this.ringingJournalForm.nRinging--;
    },

    validateForm() {
      let passed = true;

      this.ringingJournalForm.lots_sel.forEach((lot_id) => {
        let count = 0;

        for (const key in this.ringingJournalForm.inputs) {
          let split = key.split('-');
          if (split[0] == lot_id) {
            if (
              this.ringingJournalForm.inputs[key] != '' &&
              this.ringingJournalForm.inputs[key] != null
            ) {
              count++;
            }
          }
        }

        if (count == 0) {
          passed = false;
        }
      });

      if (
        this.ringingJournalForm.nRinging !=
        this.ringingJournalForm.lots_sel.length
      ) {
        return this.validationInputsRequired('lots');
      } else if (
        passed == false ||
        Object.keys(this.ringingJournalForm.inputs).length == 0
      ) {
        SweetAlert.warning(
          i18n.t('sweet_alert.production.missing_ringing_info')
        );
      } else {
        this.storeUpdateRingingJournal();
      }
    },

    storeUpdateRingingJournal() {
      this.showHideLoading(true);

      if (this.isCreate() || this.isUpdate()) {
        this.ringingJournalForm.route = 'ringings/journals/store';
        Axios.saveMaster(this.ringingJournalForm)
          .then((response) => {
            this.ringingJournalForm.lots_sel_bck = Object.assign(
              [],
              this.ringingJournalForm.lots_sel
            );
            this.ringingJournalForm.inputs_bck = Object.assign(
              {},
              this.ringingJournalForm.inputs
            );
            this.old_lots_sel = Object.assign(
              [],
              this.ringingJournalForm.lots_sel
            );

            if (typeof response.data.data.id !== 'undefined') {
              this.ringingJournalForm.id = response.data.data.id;
            }

            if (Object.keys(response.data.data.inputs_ids).length) {
              this.ringingJournalForm.inputs_ids =
                response.data.data.inputs_ids;
            }

            this.showHideLoading();
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-settings-90',
              `${i18n.t('common_words.success_operation')}...`
            );
            this.hideView();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    DeleteAll() {
      SweetAlert.delete(this.ringingJournalForm.date).then((result) => {
        if (result.value) {
          if (this.ringingJournalForm.id && this.isDelete()) {
            this.showHideLoading(true);
            this.ringingJournalForm.route = 'ringings/journals';
            Axios.destroyMaster(this.ringingJournalForm)
              .then((response) => {
                this.cleanView();
                this.ringingJournalForm.nRinging = 1;
                this.showHideLoading();
                this.showNotification(
                  `${response.data.message}`,
                  'success',
                  'nc-settings-90',
                  `${i18n.t('common_words.successful_deletion')}...`
                );
                this.hideView();
              })
              .catch((error) => this.showMessageErrors(error));
          } else {
            if (!this.isDelete()) this.showMessageAccess();
          }
        }
      });
    },
  },

  created() {
    this.permissionsForm = { ...this.dynamicModel, ...this.permissionsForm };
    this.showHideLoading(true);

    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('ringings/causes')
        .then((r1) => {
          Axios.getMasters('farms/farms/only').then((r2) => {
            this.ringing_reasons = r1.data.data;
            this.farms = r2.data.data;
            this.showHideLoading();
          });
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('ringings');
  },

  destroyed() {
    this.deselectedItemOnMenu('ringings');
  },
};
</script>
<style>
.table-journals td:empty {
  visibility: hidden;
}
.table-journals td:blank {
  visibility: hidden;
}
</style>
